import type { ConfigData } from "@configs/config-data.type";
import { localCfg } from "@configs/config.local";
import { sacylDXCfg } from "@configs/config.sacyl.dx";
import { sacylPXCfg } from "@configs/config.sacyl.px";
import { sacylEXCfg } from "@configs/config.sacyl.ex";

// record keys must be equal to associated subdomains
export const configs: Record<string, ConfigData> = {
	'local': localCfg, // default config, all versions
	// from this point forward, import configs by project branch
	'core': sacylDXCfg,
	'front-core-resi': sacylPXCfg,
	'fescyl-front-core': sacylEXCfg,
};
